import React, { useEffect, useState, useCallback } from 'react'
import { Col, Row, Card, Table, Button } from '@themesberg/react-bootstrap'
import { getAllDayOff, deleteDayOff } from '../../../../controller/api/day-off';
import AddDayOff from '../sub-screen/add-day-off/AddDayOff';
import { useCookies } from 'react-cookie';
import { calculatePage } from '../../../../helper/helper';
import Pagination from '../../../../components/Pagination';
import moment from 'moment';

const TableRow = (props) => {
  const { id, description, date, token, listGame } = props

  const [isLoading, setIsLoading] = useState(false)

  const [isDeleted, setIsDeleted] = useState(false)

  const formatedDate = moment(date).format("DD/MM/YYYY")

  const _onDelete = useCallback(async () => {
    const confirmed = window.confirm(`Bạn muốn xóa ngày nghỉ ${formatedDate}`)

    if (confirmed) {
      setIsLoading(true)
      const resp = await deleteDayOff(token, id)

      if (resp) {
        setIsDeleted(true)
      }
    }
  }, [id, formatedDate, token])

  return (
    <>
      <tr>
        {
          isDeleted ?
            <td className='text-danger' style={{ width: 250 }}>
              Đã xóa
            </td> :
            isLoading ?
              <td className='text-danger' style={{ width: 250 }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Đang xử lý</span>
                </div>
              </td> :
              <td style={{ width: 250 }}>
                <Button variant="danger" className="m-1" onClick={_onDelete}>Xóa</Button>
              </td>
        }
        <td>
          {formatedDate}
        </td>
        <td>
          {description || ""}
        </td>
        <td>
          {listGame.join(' , ') || ""}
        </td>
      </tr>
    </>
  );
};

export default () => {

  const [data, setData] = useState({})

  const [page, setPage] = useState(0)

  const [loaded, setLoaded] = useState(false)

  const [cookies] = useCookies(['lottmekong'])

  const [modalShow, setModalShow] = useState(false)

  const getAllFunc = useCallback(async () => {
    const response = await getAllDayOff(cookies.lottmekong, page)

    if (response) {
      const res = {
        list: response.data,
        total: response.total,
        totalPage: calculatePage(response.total)
      }

      setData(res || {})
      setLoaded(true)
    }
  }, [cookies.lottmekong, page])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc])

  const onAddBankPress = async () => {
    setModalShow(true)
  }

  return (
    <>
      <Button className='mb-3' style={{ marginRight: 20 }} variant="success" type="button" onClick={onAddBankPress}>Thêm</Button>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <h5>Ngày nghỉ ({data.total})</h5>
            </Col>
          </Row>
        </Card.Header>
        <Table responsive className="align-items-center table-flush">
          <thead className="thead-light">
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Ngày</th>
              <th scope="col">Mô tả</th>
              <th scope="col">Trò chơi</th>
            </tr>
          </thead>
          <tbody>
            {data.list && data.list.map(pv => <TableRow token={cookies.lottmekong} key={`dayoff-status-${pv.id}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={data.totalPage}
                currentPage={page}
                onPageChange={(i) => {
                  setLoaded(false)
                  setPage(i)
                }}
              />
            </Col>
            <Col>
              {loaded ? '' : 'Đang tải dữ liệu'}
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <AddDayOff
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};